import { ProcessoMovimentacao } from './processo-movimentacao';
import { Participante } from './participante.model';
import { ProcessoInstancia } from './processo-instancia.model';

export class Processo {

  public Id: number;
  public Tipo: string;
  public ProcessoAdvogado: ProcessoAdvogado[];
  public Cliente: Participante;
  public ClienteId: number;
  public ClienteNome: string;
  public TipoDeAcaoId: number;
  public PosicaoDoClienteId: number;
  public EstadoDoProcessoId: number;
  public DataUltimaModificacaoEstado: Date;
  public NaturezaDeAcaoId: number;
  public RitoId: number;
  public EncaminhadoPor: number;
  public EncaminhadoNome: string;
  public ParteContraria: string;
  public SubstabelecidoPor: number;
  public SubstabelecidoNome: string;
  public OutrosAutores: string;
  public AtividadeExercida: string;
  public Testemunha1: string;
  public Testemunha2: string;
  public Testemunha3: string;
  public Observacao: string;
  public ObservacaoMovimentacao: string;
  public Entrevista: string;
  public Ficha: string;
  public UnidadeId: number;
  public EstadoDoProcesso: string;

  public Instancias: ProcessoInstancia[]

  public ValorPorcentualCliente: number;
  public ValorPorcentualEscritorio: number;

  public EntrevistaId?: number;
  public Ativo: boolean;
  public DataAssinaturaContrato: string;
  public Arquivado: boolean;

  public DataEfetivaEstadoProcesso?: string;

  constructor() {
    this.Id = 0;
    this.ProcessoAdvogado = [];
    this.ClienteNome = '';
    this.Tipo = '';
    this.EncaminhadoNome = '';
    this.Ficha = '';
    this.Instancias = [];
  }
}

export class ProcessoAdvogado {
  public ProcessoId: number;
  public AdvogadoId: number;
  public AdvogadoNome: string;
}

export class Instancia {
  public Id: number;
  public InstanciaId: number;
  public ProcessoId: number;
  public NomeDepartamento: string;
  public Numero: string;
  public NumeracaoUnica: string;
  public Ordem: number;
  public Descricao: string;
  public DescricaoInstancia: string;
  public Multipla: boolean;
}


export class ProcessoConsulta {
  public Id: number;
  public ClienteId: number;
  public ClienteCNPJ_CPF: string;
  public ClienteCelular: string;
  public ClienteEmpresaTelefone: string;
  public ClienteNome: string;
  public ClienteTelefone: string;
  public OutrosAutores: string;
  public EstadoDoProcesso: string;
  public Ficha: string;
  public NaturezaDeAcao: string;
  public ParteContraria: string;
  public PosicaoDoCliente: string;
  public Tipo: string;
  public TipoDeAcao: string;
  public EncerradoOuInativo: boolean;
  public InformacoesProcessoInstancia: Instancia[];
  public ListaGrupoInstancia: Map<string, Instancia[]>;
  constructor() {
    this.Id = 0;
    this.ListaGrupoInstancia = new Map();
  }
}

export class ProcessoResumo {
  public Id: number;
  public CidadeId: string;
  public Descricao: string;
  public Tipo: string;
  public ClienteId: number;
  public ClienteNome: string;
  public ClienteCNPJ_CPF: string;
  public ClienteCelular: string;
  public ClienteTelefone: string;
  public ClienteEmpresaTelefone: string;
  public OutrosAutores: string;
  public Advogado: Array<string>;
  public EncaminhadorId: string; // TODO: Remover caso não seja usado, só deixei aqui por garantia caso precise trocar rapidamente
  public EncaminhadorNome: string;
  public NaturezaDeAcao: string;
  public ParteContraria: string;
  public TipoDeAcao: string;
  public PosicaoDoCliente: string;
  public Ficha: string;
  public EstadoDoProcesso: string;
  public QtdProcessosAtivo: number;
  public QtdProcessosEncerradosOuInativos: number;
  public QtdProcessosArquivados: number;
  public QtdProcessosOutros: number;
  public Foto: string;
  public DoumentosPendentes: Array<string>;
  public InstanciasProcesso: Array<Instancia>;
  public DataAssinaturaContrato: string;
  public PossuiAnotacaoFinanceira: boolean;
  public Arquivado: boolean;

  constructor() {
    this.Id = null;
    this.Tipo = '';
  }
}

export class UltimasMovimentacoes {
  public MovimentacaoAdministrativa: ProcessoMovimentacao[];
  public MovimentacaoExecucaoProvisoria: ProcessoMovimentacao[];
  public MovimentacaoJudicial: ProcessoMovimentacao[];
}
export class ProcessoPesquisaCliente {

  public Nome: string;
  public CNPJ_CPF: string;
  public Celular: string;
  public Telefone: string;

  constructor() {
  }
}
